/**
 * The app's single React Query client.
 *
 * Lifted out of ``App.tsx`` (HOF-93) so that code which is not a component —
 * ``AuthContext.logout`` — can reach it without ``useQueryClient()``. That
 * matters concretely: ``AuthProvider`` is rendered INSIDE
 * ``QueryClientProvider`` in the app, but several suites mount it on its own
 * (``contexts/__tests__/AuthContext.test.tsx``, and see ``frontend/CLAUDE.md``
 * on ``SettingsPage``), and a hook call there throws *"No QueryClient set"*.
 * A module singleton has no provider to be outside of.
 *
 * **The defaults are unchanged from the ones App.tsx has carried.** In
 * particular ``staleTime`` is already 5 minutes app-wide, which is worth
 * knowing when reading a per-query ``staleTime``: a hook that sets 30 s is
 * NARROWING the app default, not widening anything.
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
